// @ts-nocheck

import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { AlertCircle, Pencil } from 'lucide-react';
import { Dialog } from '@/components/ui/dialog';
import { KbDialogContent, KbDialogHead } from './Kbdialogparts';
import { KNOWLEDGE_BASE_TYPE_OPTIONS } from '@/utilities/constant';
import { AI_NAME_MAX_LENGTH } from '@/utilities/aiAgentsStore';

export default function EditKnowledgeBaseDialog({ open, onOpenChange, row, onSave }: any) {
  const [name, setName] = useState('');
  const [kbType, setKbType] = useState(KNOWLEDGE_BASE_TYPE_OPTIONS[0]?.value || 'general');
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (row) {
      setName(row.name ?? row.kb_name ?? '');
      setKbType(row.kb_type ?? row.type ?? KNOWLEDGE_BASE_TYPE_OPTIONS[0]?.value ?? 'general');
      setErrors({});
    }
  }, [row]);

  const handleSave = () => {
    if (!name.trim()) {
      setErrors({ name: 'Name is required' });
      return;
    }
    if (name.trim().length > AI_NAME_MAX_LENGTH) {
      setErrors({ name: `Name must be ${AI_NAME_MAX_LENGTH} characters or fewer` });
      return;
    }
    onSave?.({ ...row, name: name.trim(), kb_type: kbType });
    toast.info('Updated locally. This service has no edit/update API yet, so nothing was sent to the server.');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <KbDialogContent className="sm:max-w-lg">
        <KbDialogHead icon={Pencil} title="Edit knowledge base" sub="Rename it or change its type." />

        <div className="ags-dlgnote">
          <AlertCircle className="ags-i" />
          <span>No update endpoint exists on the Knowledge Base service yet. Changes here are local only and won&apos;t be saved to the server.</span>
        </div>

        <div className="ags-field">
          <label htmlFor="edit-kb-name">
            Name <span className="ags-r">*</span>
          </label>
          <input
            id="edit-kb-name"
            className={`ags-ctl${errors.name ? ' ags-invalid' : ''}`}
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={AI_NAME_MAX_LENGTH}
            autoComplete="off"
          />
          <div className="ags-cnt">
            <span style={{ color: 'var(--red)' }}>{errors.name || ''}</span>
            <span>
              {name.length} of {AI_NAME_MAX_LENGTH}
            </span>
          </div>
        </div>

        <div className="ags-field" style={{ marginBottom: 0 }}>
          <label htmlFor="edit-kb-type">Type</label>
          <select id="edit-kb-type" className="ags-ctl" value={kbType} onChange={(e) => setKbType(e.target.value)}>
            {KNOWLEDGE_BASE_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="ags-dlgfoot">
          <button type="button" className="ags-btn" onClick={() => onOpenChange(false)}>
            Cancel
          </button>
          <button type="button" className="ags-btn ags-primary" onClick={handleSave}>
            Save
          </button>
        </div>
      </KbDialogContent>
    </Dialog>
  );
}
